var render = function render(){var _vm=this,_c=_vm._self._c;return _c('markdown-field-view',{directives:[{name:"safe-html",rawName:"v-safe-html:[$options.safeHtmlConfig]",value:(_vm.rawContent),expression:"rawContent",arg:_vm.$options.safeHtmlConfig}],ref:"content",attrs:{"is-loading":_vm.isLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }